/* eslint-disable camelcase */

import React from 'react'

import PropTypes from 'prop-types'
import { MdChat } from 'react-icons/md'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { above, colors, space } from '../../style/design-system'
import GetStarted from '../reusables/GetStarted'

let StickyMobileFooter = ({ className, _r_persona }) => {
  if (_r_persona.name === 'umaWorkHere') {
    return null
  }

  const renderLeftCTA = () => {
    return (
      <button
        className="chat ga-chat live-person-wrapper btn-green cta__chat"
        id="liveperson-mobile-button"
        ga-label="mobile footer"
        aria-label="Chat now"
        type="button">
        <MdChat className="md-chat d-none d-sm-inline-block" />
        <span>Chat Now</span>
      </button>
    )
  }

  return (
    <div className={className}>
      {renderLeftCTA()}
      <GetStarted className="btn-green" pageLocation="Sticky Mobile Footer" />
    </div>
  )
}

StickyMobileFooter = styled(StickyMobileFooter)`
  z-index: 10;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${colors.umaGreen};
  display: flex;
  justify-content: center;
  ${above.lg`
    display: none;
  `}

  * {
    color: #fff;
  }
  a,
  button {
    font-size: 0.9375rem;
    font-size: 1.3rem;
    text-decoration: none;
  }
  button {
    border: none;
  }
  svg {
    vertical-align: baseline;
    width: 1.3rem;
    &.md-chat {
      font-size: 1.7rem;
      margin: 0 0.5rem -0.4rem 0;
    }
  }
  > button,
  > a {
    flex: 0 0 50%;
    padding: 0.6875rem 0;
    border: ${space.a} solid #fff;
    :first-child {
      border-left: 0;
      border-right-width: 0.0625rem;
    }
    :last-child {
      border-left-width: 0.0625rem;
      border-right: 0;
    }
  }
  .job-board {
    text-align: center;
    &:hover {
      color: #fff;
      text-decoration: none;
    }
  }
  .chat {
    position: relative;
    div {
      font-size: 0.5rem;
    }
    .live-person-wrapper > div {
      position: absolute !important;
      z-index: 99999 !important;
      top: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
    }
  }
  p {
    margin: 0;
  }
`

StickyMobileFooter.propTypes = {
  _r_persona: PropTypes.shape({
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
  }),
  className: PropTypes.string,
}

StickyMobileFooter.defaultProps = {
  _r_persona: {
    name: 'umaOnline',
  },
  className: '',
}

const mapStateToProps = (state) => ({
  _r_persona: state.persona,
})

export default connect(mapStateToProps)(StickyMobileFooter)
